import React, { ReactNode } from 'react'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay
} from '@chakra-ui/react'
import { css } from '@emotion/react'
import { brandColors } from 'shared/basicPalette'
import { TopicVersionType } from 'front-end/src/graphql/private/PrivateSchemaTypes'

type TopbarDrawerProps = {
  show: boolean
  onHide: () => void
  children: ReactNode
  title?: string
  isEditMode?: boolean
  topicType?: TopicVersionType
}

const topOffset = '136px'

export const TopbarDrawer = ({
  show,
  onHide,
  children,
  title,
  isEditMode = false,
  topicType
}: TopbarDrawerProps) => {
  const bottomOffset =
    topicType === TopicVersionType.m && isEditMode ? '80px' : '0px'
  return (
    <Drawer
      isOpen={show}
      placement="right"
      onClose={onHide}
      trapFocus={false}
      lockFocusAcrossFrames={false}
    >
      <DrawerOverlay
        zIndex={2}
        top={topOffset}
        css={css`
          & + div {
            top: ${topOffset};
            z-index: 3;
          }
        `}
      />
      <DrawerContent
        mt={topOffset}
        h={`calc(100vh - ${topOffset} - ${bottomOffset})`}
        maxW="400px"
        overflowY="auto"
        bgColor={isEditMode ? brandColors.white : brandColors.grey.lightest}
      >
        {title && (
          <DrawerHeader bgColor={brandColors.white}>{title}</DrawerHeader>
        )}
        {children}
      </DrawerContent>
    </Drawer>
  )
}
